<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="modal-text">
        <article class="reason">
          <h3>{{ $t('more_info.rooms') }}</h3>
          <p v-html="moreInfo.hotel_info.rooms"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.restaurant') }}</h3>
          <p v-html="moreInfo.hotel_info.restaurant_bars"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.breakfast') }}</h3>
          <p v-html="moreInfo.hotel_info.breakfast_charges"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.leisure') }}</h3>
          <p v-html="moreInfo.hotel_info.leisure_facilities"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.disabled') }}</h3>
          <p v-html="moreInfo.hotel_info.disabled_facilities"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.transfer') }}</h3>
          <p v-html="moreInfo.hotel_info.transfer_details"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.journey') }}</h3>
          <p v-html="moreInfo.hotel_info.distance_from_airport"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.charge') }}</h3>
          <p v-html="moreInfo.hotel_info.transfer_fee"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.parking') }}</h3>
          <p v-html="moreInfo.hotel_info.parking_arrangements"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.additional_days') }}</h3>
          <p v-html="moreInfo.hotel_info.additional_days_parking_charge"></p>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.additional') }}</h3>
          <p v-html="moreInfo.hotel_info.additional_notes"></p>
        </article>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <hotel-right-col />
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";
import { HotelRightCol } from "@/components";

export default {
  name: "HotelInformation",
  mixins: [mixins.validate, mixins.globals, mixins.format], 
  components: { HotelRightCol },
  computed: {
    airport: get("results/airport"),
    moreInfo: sync("modals/moreInfo")
  }
};
</script>